import { getCommonResultMessage, RequestError } from '@zoryn/network'

export function formatQueryError(error: unknown, fallback = '数据加载失败'): string {
  if (error instanceof RequestError) {
    return error.message || fallback
  }
  if (error instanceof Error) {
    return error.message || fallback
  }
  if (error != null && typeof error === 'object') {
    const msg = getCommonResultMessage(error)
    if (msg && msg !== '请求失败') {
      return msg
    }
    const code = (error as { code?: number }).code
    if (code === 401) {
      return '未登录或登录已过期'
    }
  }
  if (typeof error === 'string' && error) {
    return error
  }
  return fallback
}
